/**
 * Specialties Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "../../../constants/AppConfig";

// States
const state = {
    consultationTypes: [],
    consultationType: {}
};

// Getters
const getters = {
    consultationTypes: state => {
        return state.consultationTypes
    },

    consultationType: state => {
        return state.consultationType
    }
};

// Actions
const actions = {
    getConsultationTypes(context, payload) {
        function successCallback(response) {
            context.commit('getConsultationTypesHandler', { consultationTypes: response.data.consultationTypes });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ConsultationType.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getConsultationType(context, payload) {
        function successCallback(response) {
            context.commit('getConsultationTypeHandler', { consultationType: response.data.consultationType });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ConsultationType.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createConsultationType(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'consultationType', params: { consultationType: response.data.consultationType.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ConsultationType.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateConsultationType(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'specialty' });

            router.push({ name: 'consultationType', params: { consultationType: response.data.consultationType.slug } });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.ConsultationType.Create.url + '/' + payload.slug;

        Vue.axios.put(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(successCallback)
        .catch(errorCallback);

        // makeApiRequest(payload.args, apiModel.Specialty.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteConsultationType(context, payload) {
        function successCallback(response) {
            context.commit('deleteConsultationTypeHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ConsultationType.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getConsultationTypesHandler(state, { consultationTypes }) {
        // Update specialties state
        state.consultationTypes = consultationTypes;
    },

    getConsultationTypeHandler(state, { consultationType }) {
        // Update specialty state
        state.consultationTypes = consultationType;
    },

    deleteConsultationTypeHandler(state, { index, successMessage }) {
        let i = state.consultationTypes.findIndex(consultationType => consultationType.slug === index);

        if (~i) {
            state.consultationTypes.splice(i, 1);

            router.push({ name: 'consultationType' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
